/**
 * Códigos fixos de destino no fluxo MCE / canal externo (não são produtos).
 * Ex.: MY-SUBSCRIPTIONS → /my-account/plans
 *      PENDING-ORDERS → /my-account/pending-orders
 */
export type MceRedirectDestinationCode = 'MY-SUBSCRIPTIONS' | 'PENDING-ORDERS';

export const MCE_REDIRECT_DESTINATIONS: Record<MceRedirectDestinationCode, string> = {
  'MY-SUBSCRIPTIONS': '/my-account/plans',
  'PENDING-ORDERS': '/my-account/pending-orders',
};

const MCE_REDIRECT_DESTINATION_CODES = Object.keys(
  MCE_REDIRECT_DESTINATIONS
) as MceRedirectDestinationCode[];

export function normalizeMceRedirectDestinationCode(
  value: string | null | undefined
): MceRedirectDestinationCode | null {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toUpperCase();
  return MCE_REDIRECT_DESTINATION_CODES.includes(normalized as MceRedirectDestinationCode)
    ? (normalized as MceRedirectDestinationCode)
    : null;
}

export function resolveMceRedirectDestinationPath(
  value: string | null | undefined
): string | null {
  const code = normalizeMceRedirectDestinationCode(value);
  return code ? MCE_REDIRECT_DESTINATIONS[code] : null;
}
